import request from '@/utils/request';

//克隆模型列表
export function getCloneVoiceList(params) {
    return request({
        method: 'get',
        url: 'voice/getCloneList',
		params
    })
}



// 克隆声音
export function cloneVoice(data) {
    return request({
        method: 'post',
        url: 'voice/submitUserVoiceClone',
		data:data
    })
}

export function editCloneVoice(data) {
    return request({
        method: 'post',
        url: 'voice/editCloneVoice',
		data:data
    })
}

export function deleteClone(params) {
    return request({
        method: 'get',
        url: 'voice/deleteClone',
		params
    })
}

